export default __webpack_public_path__ + "static/media/bucks-icon.80c8b7fc.jpeg";